export { Modal, type ModalProps } from "~/components/Modal/Modal";
